export default __webpack_public_path__ + "static/media/level-6.be22726b.png";